export default __webpack_public_path__ + "media/zurb/img/case-study-cartpros/cartpros-img3-a1dc56b5af25071a6c5ab18f2e7b63b7.jpg";